export default __webpack_public_path__ + "static/media/dot-dark.a4a2284c.svg";